type ImageDimensions = {
  originalWidth: number;
  originalHeight: number;
};

type ThumbnailCrop = {
  cropCoordinates: {
    height: number; // Percentage as a whole number (e.g., 100 for 100%)
    width: number; // Percentage as a whole number
  };
};

type CropDimensions = {
  height: number;
  width: number;
};

type ImageParams = {
  url: string;
  width?: number;
  quality?: number;
};

export const SOCIAL_IMAGE_MAX_WIDTH: number = 1200;

export const getThumbnailDimensions = (
  image: ImageDimensions,
  thumbnail: ThumbnailCrop,
): CropDimensions => {
  const { originalWidth, originalHeight } = image;
  const { width, height } = thumbnail.cropCoordinates;

  // Convert percentages to fractions of 1
  const widthFraction = width / 100;
  const heightFraction = height / 100;

  const cropHeight = Math.floor(originalHeight * heightFraction);
  const cropWidth = Math.floor(originalWidth * widthFraction);

  return { width: cropWidth, height: cropHeight };
};

// Set additional params for images served by the WP Site Accelerator CDN
// https://developer.wordpress.com/docs/site-performance/site-accelerator-cdn/
// There are other params we can add if we need them
export const setImageParams = ({
  url,
  width,
  quality,
}: ImageParams): string => {
  const imageUrl = new URL(url);
  if (width) {
    imageUrl.searchParams.set("w", width.toString());
  }
  if (quality) {
    imageUrl.searchParams.set("quality", quality.toString());
  }
  return imageUrl.toString();
};
